import Box from "@mui/material/Box";
import React from "react";

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
  gridLayout?: boolean;
};
function TabPanel(props: TabPanelProps) {
  const { children, value, index, gridLayout, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && gridLayout ? (
        children
      ) : (
        <Box sx={{ p: 3 }}>{children}</Box>
      )}
    </div>
  );
}

export default TabPanel;
